import { TooltipComponent } from "components/toolTipComponent/TooltipComponent";
import type { ReactNode } from "react";
import { useSelector } from "react-redux";
import { selectSpEnvironment } from "state/selectors/Selectors";

interface NavigationItemProps {
    title: string;
    selected: boolean;
    href: string;
    itemOrder: number | undefined;
    onClick: () => void;
    tooltipContent: ReactNode;
    index: number;
}

const NavigationItem = ({ title, selected, href, itemOrder, onClick }: NavigationItemProps) => {
    const spEnv = useSelector(selectSpEnvironment);

    const cn = (...x: (string | false | null | undefined)[]) =>
        x.filter(Boolean).join(" ");
    return (
        <div key={title}>
            <a
                rel="noopener noreferrer"
                role="radio"
                aria-checked={selected}
                href={href}
                onClick={onClick}
                className={cn(
                    `rounded-md px-3 py-2 text-sm font-medium !text-white !no-underline hover:!no-underline ${spEnv === "logp" ? "hover:bg-[#003d4c]" : "hover:bg-[#007167]" } focus:!outline-none  focus:ring-offset-2 transition-colors duration-200`
                )}
            >
                {itemOrder === 1 && spEnv === "logistikportalen" ?
                    <>
                        <TooltipComponent
                            content="Denna länk tar dig till den interna startsidan, krävs behörighet."
                            tooltipClassName="mb-[15px]!"
                        >
                            🔒 {title}
                        </TooltipComponent>
                    </>
                    :
                    title
                }
            </a>
        </div>
    )
}

export default NavigationItem;